import * as React from 'react';
import { DefaultSortOrder, DomainNode, SortOptions } from 'ui/sort-order/types';
import { SortBySelect } from 'ui/sort-order/sort-by-select/sort-by-select';
import { moveSortOrderType, sortOrderType } from 'ui/sort-order/constants';
import { ComplexValue } from 'ui/common/types';
import { MeatballMenu, RadioSymbol } from 'ui';
import styles from './sort-by-item.scss';

export interface SortByListItemProps {
  sortByItem: DefaultSortOrder;
  options: SortOptions;
  translation: any;
  index: number;
  onSelectedOptions: (sortByItem: DefaultSortOrder) => DomainNode[];
  onMove: (type: number, value: number) => void;
  onDefaultOrderChange: (sortByItem: DefaultSortOrder) => void;
  onDefaultOrderRemove: (index: number) => void;
}

export interface SortByListItemState {
  value: number;
}

export class SortByListItem extends React.Component<SortByListItemProps, SortByListItemState> {

  public static getDerivedStateFromProps (props: SortByListItemProps) {
    return {
      value: props.sortByItem.sortOrderType
    };
  }

  constructor(props: SortByListItemProps) {
    super(props);
    this.state = {
      value: props.sortByItem.sortOrderType
    };
  }

  private onSortOrderTypeChange = (e: React.SyntheticEvent<any>) => {
    this.setState({
      value: parseInt(e.currentTarget.value, 10)
    } as SortByListItemState);

    const oldSortByItem = this.props.sortByItem;

    const newSortByItem = Object.assign({}, oldSortByItem, {
      sortOrderType: parseInt(e.currentTarget.value, 10)
    });

    this.props.onDefaultOrderChange(newSortByItem);
  };

  private handleRemove = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    this.props.onDefaultOrderRemove(this.props.index);
  };

  private onChange = (item: ComplexValue<number>) => {
    this.props.onDefaultOrderChange(!item ? this.props.sortByItem : Object.assign({},
      this.props.sortByItem, {
        domainNode: {
          value: item.value,
          description: item.description
        }
      }));
  };

  private onMoveUp = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    this.props.onMove(this.props.sortByItem.domainNode.value, moveSortOrderType.UP);
  };

  private onMoveDown = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    this.props.onMove(this.props.sortByItem.domainNode.value, moveSortOrderType.DOWN);
  };

  private minNumber = () => {
    return Math.min(...this.props.options.defaultSortOrder.map((curr) => {
      return curr.orderBySequence;
    }));
  };

  private maxNumber = () => {
    return Math.max(...this.props.options.defaultSortOrder.map((curr) => {
      return curr.orderBySequence;
    }));
  };

  private renderMenu = () => (
    <div className={styles.sortMeatballMenu}>
      <MeatballMenu closeAfterClick>
        <span>
          <li><button type="button" className="dropdown-item" onClick={this.handleRemove}>
            {this.props.translation.sort_order_menu_option_remove}
          </button></li>
          {this.props.sortByItem.orderBySequence !== this.minNumber()
            ? <li><button type="button" className="dropdown-item" onClick={this.onMoveUp}>
            {this.props.translation.sort_order_menu_option_move_up}
          </button></li> : null}
          {this.props.sortByItem.orderBySequence !== this.maxNumber()
            ? <li><button type="button" className="dropdown-item" onClick={this.onMoveDown}>
            {this.props.translation.sort_order_menu_option_move_down}
          </button></li> : null}
        </span>
      </MeatballMenu>
    </div>);

  public render() {
    return (<div className={styles.sortByTile}>
      <div className={styles.sortByTileTop}>
        <span className={`control-label ${styles.sortLabel}`}>
          {this.props.translation.sort_order_sort_by}
        </span>
        {this.props.options.defaultSortOrder.length !== 1 ? this.renderMenu() : null}
      </div>
      <div className={styles.sortByWrapper}>
        <div className={styles.uiSortByTileTitle}>
          <SortBySelect
            options={this.props.onSelectedOptions(this.props.sortByItem)}
            translation={this.props.translation}
            valueItem={this.props.sortByItem.domainNode}
            onChange={this.onChange} />
        </div>
        <fieldset className={styles.sortOrderList}>
          <legend className="visuallyhidden">
            {this.props.translation.sort_order_sort_by}
          </legend>
          <div className="form-check form-check-inline">
            <input type="radio" id={`asc_${String(this.props.index)}`}
              name={String(this.props.index)}
              className="form-check-input visuallyhidden"
              value={sortOrderType.ASC}
              checked={this.state.value === sortOrderType.ASC}
              onChange={this.onSortOrderTypeChange} />
            <label htmlFor={`asc_${String(this.props.index)}`} className="form-check-label media">
              <RadioSymbol/>
              {this.props.translation.sort_order_asc}
              <div className={`${styles.ascLabel}`}/>
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input type="radio" id={`desc_${String(this.props.index)}`}
              name={String(this.props.index)}
              className="form-check-input visuallyhidden"
              value={sortOrderType.DESC}
              checked={this.state.value === sortOrderType.DESC}
              onChange={this.onSortOrderTypeChange}/>
            <label htmlFor={`desc_${String(this.props.index)}`} className="form-check-label media">
              <RadioSymbol/>
              {this.props.translation.sort_order_desc}
              <div className={`${styles.descLabel}`}/>
            </label>
          </div>
        </fieldset>
      </div>
    </div>);
  }
}
